<template>
  <div>
    <div class="ed-itemTabs clr">
      <template v-if="item.fair_ids">
        <template v-for="(eventId, index) in item.fair_ids">
          <template v-if="eventId in eventLookup">
            <template v-if="Number.parseInt(eventId) === medizinEventId">
              <div :key="index" style="margin-top: 32px"></div>
            </template>
            <template v-else>
              <Flag :key="index" :event-id="Number.parseInt(eventId)" :event-lookup="eventLookup"/>
            </template>
          </template>
        </template>
      </template>
    </div>
    <div class="ed-grid">
      <div class="ed-grid__item ed-grid__item--1">
          <template v-if="speaker.av_p_image_url">
            <img :src='speaker.av_p_image_url' class="fp-contacts_img" :class="{'fp-contacts_img__mobile': view_size_mode <= 2}">
          </template>
          <template v-else>
            <img :src="getAvatarImg" class="fp-contacts_img" :class="{'fp-contacts_img__mobile': view_size_mode <= 2}">
          </template>
      </div>
      <div class="ed-grid__item ed-grid__item--2" :class="{'ed-grid__item--2--terminalMode': terminalmode}">
        <div class="ed-text">
          <h3
            class="ed-text__title ed-text__title--link"
            aria-haspopup="true"
            :title="$t('list.linkToDetailTooltip')"
            @click="updateRoute(speaker)">
            {{ speaker.fp_title }} {{ speaker.fp_firstname }} {{ speaker.fp_lastname }}
          </h3>
          <p class="ed-text__description clr">
            <span v-if="personData && personData.company">{{ personData.company }}</span>
            <span v-if="speaker.fp_position"><br>{{ speaker.fp_position }}</span>
          </p>
        </div>
      </div>
    </div>
    <ButtonComponent @updateRoute="updateRoute" :view_size_mode="view_size_mode" :terminalmode="terminalmode"/>
  </div>
</template>

<script>
import Flag from './Flag.vue';
import ButtonComponent from './ButtonComponent.vue';

export default {
  name: 'Speaker',
  components: {
    Flag,
    ButtonComponent,
  },
  data() {
    return {
      medizinEventId: 35076,
    };
  },
  props: {
    speaker: {
      type: Object,
      required: true,
    },
    item: {
      type: Object,
      required: true,
    },
    eventLookup: {
      type: Object,
      required: true,
    },
    view_size_mode: {
      type: Number,
      required: true,
    },
    fairGroups: {
      type: String,
      default: '',
    },
    getAvatarImg: {
      type: String,
      required: true,
    },
    terminalmode: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    personData() {
      if (this.speaker.fp_persons && this.speaker.fp_persons.length > 0) {
        return JSON.parse(this.speaker.fp_persons[0]);
      }
      return null;
    },
  },
  methods: {
    updateRoute() {
      this.$emit('updateRoute', this.item);
    },
  },
};
</script>

<style lang="scss">
.ed-wrapper {
  .ed-list {
    &.tile-mode {
      .ed-grid {
        .ed-grid__item {
          &.ed-grid__item--1 {
            @media screen and (max-width: 1280px) {
              height: 161px;
                  display: flex;
                  justify-content: center;
                  align-items: center;
            }
          }
        }
      }
    }
  }
}
.ed-wrapper {
  .ed-detail__segment {
    border: none;
  }
}
.fp-contacts_img {
  width: 100%;
}

.fp-contacts_img__mobile {
  width: 130px;
  height: 130px;
}
.ed-grid__item--2--terminalMode {
  width: 50% !important;
}
</style>
